import { FC, useCallback } from 'react';

import { ExpirationDate } from 'components';
import { TextField } from 'components/inputs/text-field';
import { Container } from 'types';
import { useNewTransaction } from '..';

const TrailerDetails: FC = () => {
  const { container, setContainer, isTrailer, transaction } = useNewTransaction();

  /* prettier-ignore */
  const setLicensePlate = useCallback((licensePlate: string) => {
    setContainer(prevState => new Container({ ...prevState, licensePlate }));
  }, [setContainer]);

  /* prettier-ignore */
  const setLicensePlateExpirationDate = useCallback((licensePlateExpirationDate?: number) => {
    setContainer(prevState => new Container({ ...prevState, licensePlateExpirationDate }));
  }, [setContainer]);

  /* prettier-ignore */
  const setFmcsaDate = useCallback((fmcsaDate?: number) => {
    setContainer(prevState => new Container({ ...prevState, fmcsaDate }));
  }, [setContainer]);

  return !isTrailer ? null : (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>TRAILER DETAILS</h4>
      </div>
      <div className="card-body grid-3">
        <TextField
          disabled={!transaction.inbound}
          label="LICENSE PLATE"
          onChange={setLicensePlate}
          value={container.licensePlate ?? ''}
        />
        <ExpirationDate
          date={container.licensePlateExpirationDate}
          disabled={!transaction.inbound}
          label="LP EXPIRATION"
          setDate={setLicensePlateExpirationDate}
        />
        <ExpirationDate
          date={container.fmcsaDate}
          disabled={!transaction.inbound}
          label="FMCSA DATE"
          setDate={setFmcsaDate}
        />
      </div>
    </div>
  );
};

export default TrailerDetails;
